import { SelectInput } from 'react-admin';
import { path } from './constants';
import { CountyInputProps } from './types';
import useController from './useController';

const CountyInput = ({ state, ...props }: CountyInputProps) => {
  const { counties, isDisabled } = useController({ state });

  return <SelectInput choices={counties} disabled={isDisabled} optionValue="name" source={path('county')} {...props} />;
};

export default CountyInput;
